import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export async function decryptResponse(encryptedPayload) {
  if (!encryptedPayload || typeof encryptedPayload !== 'string') {
    console.error("Decryption Error: encryptedPayload is missing or not a string.");
    return null;
  }

  const keyHex = process.env.REACT_APP_RESPONSE_KEY;
  if (!keyHex) {
    console.error("Decryption Error: REACT_APP_RESPONSE_KEY missing.");
    return null;
  }

  try {
    const raw = Uint8Array.from(atob(encryptedPayload), c => c.charCodeAt(0));

    const ivLength = 12;
    const authTagLength = 16;

    const iv = raw.slice(0, ivLength);
    const authTag = raw.slice(ivLength, ivLength + authTagLength);
    const ciphertext = raw.slice(ivLength + authTagLength);

    const keyBytes = new Uint8Array(keyHex.match(/.{1,2}/g).map(b => parseInt(b, 16)));
    const key = await crypto.subtle.importKey(
      'raw', keyBytes, { name: 'AES-GCM' }, false, ['decrypt']
    );

    const encryptedWithTag = new Uint8Array([...ciphertext, ...authTag]);
    const decrypted = await crypto.subtle.decrypt(
      { name: 'AES-GCM', iv, tagLength: 128 },
      key,
      encryptedWithTag,
    );

    const decryptedText = new TextDecoder().decode(decrypted);
    return JSON.parse(decryptedText);
  } catch (e) {
    console.error("Decryption Error:", e.message);
    return null;
  }
}

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
